import { fetch } from '../fetchWrapper/fetch';
import { API_URL, Status } from '../constants';
import { ILatestPublicationStatusResponse } from './types';

export const getMenuPublicationStatus = async (menuId: string): Promise<ILatestPublicationStatusResponse> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}/status`);
    if (res.status !== Status.SUCCESS) {
      throw new Error('Invalid status code');
    }
    const json: { data: ILatestPublicationStatusResponse } = await res.json();
    return json.data[0];
  } catch (e) {
    throw new Error('Unable to fetch publication status', e);
  }
};
